export default class InvestigationModel {
  public extensionInvestigationId: string = ''
  public extensionId: string = ''
  public name: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
